import { SURFACES, SURFACES_PRIMARY, SURFACES_SECONDARY } from '../../constants/display-options';

const updateSurfaceDependentOptions = ({ displayOptions, modifiedOption }) => {
  const surfaceOptions = [SURFACES, SURFACES_PRIMARY, SURFACES_SECONDARY];

  if (surfaceOptions.includes(modifiedOption.id)) {
    return displayOptions.map((option) => {
      if (surfaceOptions.includes(option.id) && option.id !== modifiedOption.id) {
        return {
          ...option,
          surfaces: [...modifiedOption.surfaces],
          userModified: modifiedOption.userModified,
        };
      }

      return option;
    });
  }

  return displayOptions;
};

export default updateSurfaceDependentOptions;
